





import { defineComponent } from '@vue/composition-api';

const App = defineComponent({
  // setup() {},
});

export default App;
